module.exports = {
      id: "paywalliconbenefitthree-usage",
      viewBox: "0 0 31.097 36.378",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#paywalliconbenefitthree",
      toString: function () {
        return this.url;
      }
    }